/* ==============================================
Map Point UI
============================================== */

let links;
let panels;
let markers;

const handleMapPointsInit = () => {
    links = document.querySelectorAll('#mapengine .makers-map__tab a');
    panels = document.querySelectorAll('#mapengine .markers-map__panel');
    markers = document.querySelectorAll('#mapengine .makers-map__map svg');
    links.forEach( (link,i)  => {
        console.log("index=" + i);
        link.addEventListener('click', (e)=>{
            e.preventDefault();
            toggleMapPoint(i);
            
        });
    });
    markers.forEach( (marker,i)  => {

        marker.addEventListener('click', (e)=>{
            e.preventDefault();
            toggleMapPoint(i, true);
            
        });
    });
    // -- toggle Map Point 1
    toggleMapPoint(0, false);
}


const toggleMapPoint = (index, doScroll) => {
    console.log( index + " clicked");
    links.forEach(link => {
        link.classList.remove('makers-map__tab--active');
    });
    panels.forEach(panel => {
        panel.classList.remove('active');
    });
    markers.forEach(marker => {
        marker.classList.remove('active');
    });

    links[index].classList.add('makers-map__tab--active');
    markers[index].classList.add('active');
    panels[index].classList.add('active');

 
    // -- ok so on mobile we have a div called makers-map__tab which is a horizontal scroller with links appearing off the screen. 
    



    // -- Scroll To
    if( doScroll ) {
       
        console.log( "Move horizontal scroller");
        const activeTab = document.querySelector('.makers-map__tab--active');
        const navBar = document.querySelector('.makers-map__tab');
        const navBarRect = navBar.getBoundingClientRect();
        const activeTabRect = activeTab.getBoundingClientRect();
        const scrollX = navBar.scrollLeft + activeTabRect.left - navBarRect.left - navBarRect.width / 2 + activeTabRect.width / 2;
      
        // Scroll the navigation bar to center the active tab
        navBar.scrollLeft = scrollX;


        console.log( "Scroll into view");
        var anchor = document.querySelector('#map_content_elm');
        anchor.scrollIntoView({behavior: 'smooth'});
    }



    // -- Also scroll to position on horizontal scroller
    return false;

}       


// Function to check if an element is in the viewport
function isElementInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.left >= 0 &&
      rect.top >= 0 &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
  }

document.addEventListener('DOMContentLoaded', handleMapPointsInit);